import React from 'react';
import { StatusKey } from '../types';
import { STATUS_COLORS } from '../constants';

interface PulseProps {
  status: StatusKey;
}

export default function Pulse({ status }: PulseProps) {
  const c = STATUS_COLORS[status];
  return (
    <span style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 12, height: 12 }}>
      {status !== 'checking' && (
        <span style={{
          position: 'absolute', inset: 0, borderRadius: '50%', background: c, opacity: 0.3,
          animation: status === 'online' ? 'ping 2s ease-out infinite' : 'none',
        }} />
      )}
      <span style={{ width: 8, height: 8, borderRadius: '50%', background: c, flexShrink: 0 }} />
    </span>
  );
}
